(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  /**
   * Reviews: refresh on sibling colour change, and make the info-column rating
   * badge scroll here.
   *
   * The fetch is the ONE request sanctioned in the swap path (Task 8a brief).
   * It is scheduled through requestIdleCallback AFTER the swap has painted, so
   * it can never sit on the critical path of the colour change: the gallery,
   * price, sizes and URL are all final before this function is even entered
   * (`kosha:sibling:changed` fires last — Task 6 §6), and the callback is then
   * deferred again to an idle slot.
   */
  (function () {
    if (window.koshaReviewsBound) return;
    window.koshaReviewsBound = true;

    var SEL = '[data-reviews-section]';
    var inflight = null;

    function idle(fn) {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(fn, { timeout: 2000 });
      } else {
        setTimeout(fn, 200);
      }
    }

    function refresh(handle) {
      var host = document.querySelector(SEL);
      if (!host || !handle) return;

      var sectionId = host.getAttribute('data-section-id');
      if (!sectionId) return;

      if (inflight) inflight.abort();
      var controller = new AbortController();
      inflight = controller;

      var url = '/products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(sectionId);

      performance.mark && performance.mark('kosha:reviews:fetch-start');

      fetch(url, { signal: controller.signal, headers: { Accept: 'text/html' } })
        .then(function (res) {
          if (!res.ok) throw new Error(res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector(SEL);
          // A colour with no reviews renders an empty host (or none at all).
          // Emptying ours is correct in both cases and leaves no hole.
          host.innerHTML = next ? next.innerHTML : '';
          host.hidden = !host.firstElementChild;
          host.setAttribute('data-reviews-handle', handle);
          /* What just landed in the mount is INERT Judge.me markup — see the
             note on the disclosure below. Marked only when Judge.me is
             actually on the page, because without its app embed there was
             never a live widget here to lose. */
          if (window.jdgm && window.jdgm.CDN_BASE_URL) {
            host.setAttribute('data-reviews-stale', '');
          }
          performance.mark && performance.mark('kosha:reviews:fetch-done');
          document.dispatchEvent(
            new CustomEvent('kosha:reviews:refreshed', { detail: { handle: handle } })
          );
        })
        .catch(function (err) {
          // Aborted, offline, or a 4xx: the previous render stays on screen.
          if (err && err.name === 'AbortError') return;
        })
        .finally(function () {
          if (inflight === controller) inflight = null;
        });
    }

    function revealMount(trigger, mount) {
      trigger.setAttribute('aria-expanded', 'true');
      mount.hidden = false;

      /* Judge.me's container is in the markup, but only its app embed defines
         `window.jdgm` and the CDN base its loader reads. Without the embed —
         the local preview and the `theme dev` preview theme — the container
         can never fill, so say so rather than opening an empty box. The check
         is on the global, not on the hostname, because the preview theme is
         served from the real domain and is just as empty. */
      var jdgmReady = !!(window.jdgm && window.jdgm.CDN_BASE_URL);
      var note = mount.querySelector('[data-reviews-unavailable]');
      if (note) {
        note.hidden = jdgmReady;
        var appBlock = mount.querySelector('.pdp-reviews__app-block');
        if (appBlock) appBlock.hidden = !jdgmReady;
      }

      mount.scrollIntoView({
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'nearest',
      });
    }

    // "See all N reviews" — a delegated disclosure, so it survives the whole
    // section being replaced by the refresh above (the button in the new
    // markup is a different element; a bound listener would have gone with the
    // old one).
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-reviews-more]');
      if (!trigger) return;
      var mount = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!mount) return;

      if (trigger.getAttribute('aria-expanded') === 'true') {
        trigger.setAttribute('aria-expanded', 'false');
        mount.hidden = true;
        return;
      }

      /* ---------------------------------------------------------------------
         THE SWAP KILLS THE WIDGET, AND ONLY A PAGE LOAD BRINGS IT BACK
         ---------------------------------------------------------------------
         Judge.me builds its widget ONCE per page load: the loader guards
         itself with `jdgm._loaderExecuted`, and the module behind it scans the
         DOM a single time on import. There is no public re-init hook.

         The sibling refresh above replaces `host.innerHTML` wholesale, so the
         element Judge.me filled is thrown away, and what lands in its place is
         inert: an empty container, plus a <script> carrying the new colour's
         review data that `innerHTML` will never execute. From that moment the
         disclosure opens onto nothing, for the rest of the visit.

         That is the whole of "see all reviews isn't working on shakti leggings
         azalea" (owner, 2026-09-29). Sixteen colours sit on that page, so
         reaching Azalea by its swatch is the ordinary path, and every arrival
         by swatch killed the widget. A direct load was always fine, which is
         exactly why it read as intermittent and why two rounds of checking the
         markup found nothing wrong with it.

         Reviving it in place would mean reaching into their internals, and the
         generation change traced on 2026-09-07 is what that costs. So the
         refresh marks itself and the disclosure spends one page load instead,
         which returns a widget correctly built for the colour being viewed.
         `#reviews` reopens the list on arrival, so the click still reads as
         "the button showed me the reviews". */
      var host = document.querySelector(SEL);
      if (host && host.hasAttribute('data-reviews-stale')) {
        if (window.location.hash === '#reviews') {
          window.location.reload();
        } else {
          window.location.href =
            window.location.pathname + window.location.search + '#reviews';
        }
        return;
      }

      revealMount(trigger, mount);
    });

    /* Arriving at `#reviews` — from the reload above, or from a link somebody
       shared — opens the list, rather than dropping the visitor beside a button
       they have to press a second time. */
    function openFromHash() {
      if (window.location.hash !== '#reviews') return;
      var trigger = document.querySelector('[data-reviews-more]');
      if (!trigger || trigger.getAttribute('aria-expanded') === 'true') return;
      var mount = document.getElementById(trigger.getAttribute('aria-controls'));
      if (mount) revealMount(trigger, mount);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openFromHash);
    } else {
      openFromHash();
    }

    document.addEventListener('kosha:sibling:changed', function (event) {
      var detail = event.detail || {};
      idle(function () {
        refresh(detail.handle);
      });
    });

    // The rating badge in the info column is presented as a control by
    // Judge.me (role="button") but has nothing behind it. Give it the job the
    // spec asks for: scroll to the reviews. Delegated, so it survives the
    // badge being rewritten on a colour swap.
    document.addEventListener('click', function (event) {
      var badge = event.target.closest && event.target.closest('.product__rating');
      if (!badge) return;
      var host = document.querySelector(SEL);
      if (!host || host.hidden) return;
      var target = host.querySelector('#reviews') || host;
      event.preventDefault();
      target.scrollIntoView({
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start',
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  /**
   * Related products (lazy Section Rendering fetch) + recently viewed
   * (localStorage, no network at all).
   */
  (function () {
    if (window.koshaRelatedBound) return;
    window.koshaRelatedBound = true;

    var RV_KEY = 'kosha:recently-viewed';
    var RV_MAX = 12;

    /* ------------------------------------------------------------ related */

    function loadRelated(host) {
      if (host.dataset.loaded) return;
      host.dataset.loaded = '1';

      var params = new URLSearchParams({
        section_id: host.dataset.sectionId,
        product_id: host.dataset.productId,
        limit: host.dataset.limit || '8',
        intent: host.dataset.intent || 'related',
      });

      fetch('/recommendations/products?' + params.toString(), { headers: { Accept: 'text/html' } })
        .then(function (res) {
          if (!res.ok) throw new Error(res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var payload = doc.querySelector('[data-related-payload]');
          var grid = host.querySelector('[data-related-grid]');
          if (!payload || !grid || !payload.children.length) return;
          grid.innerHTML = payload.innerHTML;
          host.hidden = false;
          document.dispatchEvent(
            new CustomEvent('kosha:related:loaded', { detail: { count: grid.children.length } })
          );
        })
        .catch(function () {
          // No recommendations, offline, or a 4xx: the row simply never appears.
        });
    }

    function watchRelated() {
      var host = document.querySelector('[data-related]');
      if (!host) return;

      if (!('IntersectionObserver' in window)) {
        loadRelated(host);
        return;
      }
      // The host is `hidden`, so it has no box to intersect. Observe its
      // wrapper, which is always laid out.
      var target = host.parentElement || host;
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            loadRelated(host);
          });
        },
        { rootMargin: '1200px 0px' }
      );
      observer.observe(target);
    }

    /* ----------------------------------------------------- recently viewed */

    function readRV() {
      try {
        var raw = window.localStorage.getItem(RV_KEY);
        var list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list : [];
      } catch (error) {
        return [];
      }
    }

    function writeRV(list) {
      try {
        window.localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, RV_MAX)));
      } catch (error) {
        /* Private mode / quota. Recently-viewed is a nicety, never a blocker. */
      }
    }

    function recordRV(entry) {
      if (!entry || !entry.h) return [];
      var list = readRV().filter(function (item) {
        return item && item.h !== entry.h;
      });
      list.unshift(entry);
      writeRV(list);
      return list;
    }

    function srcAt(url, width) {
      if (!url) return '';
      return url.indexOf('width=') > -1 ? url.replace(/width=\d+/, 'width=' + width) : url;
    }

    function tile(item) {
      var link = document.createElement('a');
      link.className = 'rv__tile';
      link.href = item.u;

      var frame = document.createElement('span');
      frame.className = 'rv__media';

      if (item.i) {
        var img = document.createElement('img');
        img.className = 'rv__img';
        img.src = srcAt(item.i, 480);
        img.srcset = [240, 360, 480]
          .filter(function (w) {
            return !item.w || w <= item.w;
          })
          .map(function (w) {
            return srcAt(item.i, w) + ' ' + w + 'w';
          })
          .join(', ');
        img.sizes = '(min-width: 750px) 180px, 40vw';
        img.width = 480;
        img.height = 600;
        img.loading = 'lazy';
        img.decoding = 'async';
        img.alt = item.t || '';
        frame.appendChild(img);
      }
      link.appendChild(frame);

      var title = document.createElement('span');
      title.className = 'rv__title';
      title.textContent = item.t || '';
      link.appendChild(title);

      if (item.p) {
        var price = document.createElement('span');
        price.className = 'rv__price';
        price.textContent = item.p;
        link.appendChild(price);
      }

      return link;
    }

    function renderRV(list, currentHandle) {
      var host = document.querySelector('[data-recently-viewed]');
      if (!host) return;
      var grid = host.querySelector('[data-rv-grid]');
      if (!grid) return;

      var max = parseInt(host.dataset.max, 10) || 6;
      var items = list
        .filter(function (item) {
          return item && item.h && item.h !== currentHandle && item.u;
        })
        .slice(0, max);

      grid.textContent = '';
      items.forEach(function (item) {
        grid.appendChild(tile(item));
      });
      host.hidden = items.length === 0;
    }

    function currentEntry() {
      var node = document.querySelector('[data-rv-current]');
      if (!node) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return null;
      }
    }

    function start() {
      var entry = currentEntry();
      var list = entry ? recordRV(entry) : readRV();
      renderRV(list, entry && entry.h);
      watchRelated();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    // A sibling swap is a page view in every sense the visitor cares about.
    // Price text is lifted from the DOM the swap has already updated, so no
    // money formatting happens in JS and no request is made.
    document.addEventListener('kosha:sibling:changed', function (event) {
      var detail = event.detail || {};
      if (!detail.handle) return;
      var priceNode = document.querySelector('[data-price-current]');
      var media = (detail.media && detail.media[0]) || {};
      var list = recordRV({
        h: detail.handle,
        t: detail.title,
        u: detail.url,
        i: media.src ? srcAt(media.src, 480) : '',
        w: media.width || 0,
        p: priceNode ? priceNode.textContent.trim() : '',
        a: detail.available !== false,
      });
      renderRV(list, detail.handle);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
